import type { RouteRecordRaw } from 'vue-router';

// 知识测验（App 内打开，入口由 App 原生提供）
const routes: RouteRecordRaw[] = [
  {
    path: '/quiz/score',
    name: 'quiz-score',
    component: () => import('@/views/quiz/ScoreView.vue'),
    meta: {
      title: '我的成绩',
      hideShare: true,
    },
  },
  {
    path: '/quiz/practice',
    name: 'quiz-practice',
    component: () => import('@/views/quiz/PracticeCenter.vue'),
    meta: {
      title: '练习中心',
      hideShare: true,
    },
  },
  {
    path: '/quiz/practice/answer',
    name: 'quiz-practice-answer',
    component: () => import('@/views/quiz/PracticeAnswer.vue'),
    meta: {
      title: '练习中心',
      hideShare: true,
    },
  },
  {
    path: '/quiz/practice/result',
    name: 'quiz-practice-result',
    component: () => import('@/views/quiz/PracticeResult.vue'),
    meta: {
      title: '答题完成',
      hideShare: true,
    },
  },
  {
    path: '/quiz/practice/analysis',
    name: 'quiz-practice-analysis',
    component: () => import('@/views/quiz/PracticeAnalysis.vue'),
    meta: {
      title: '题目解析',
      hideShare: true,
    },
  },
  {
    path: '/quiz/wrong',
    name: 'quiz-wrong',
    component: () => import('@/views/quiz/WrongBook.vue'),
    meta: {
      title: '错题本',
      hideShare: true,
    },
  },
  {
    path: '/quiz/medal',
    name: 'quiz-medal',
    component: () => import('@/views/quiz/MedalList.vue'),
    meta: {
      title: '荣誉证书',
      hideShare: true,
    },
  },
  {
    path: '/quiz/medal/detail',
    name: 'quiz-medal-detail',
    component: () => import('@/views/quiz/MedalDetail.vue'),
    meta: {
      title: '荣誉证书',
      hideShare: true,
    },
  },
];

export default routes;
